export default "__VITE_ASSET__Dy7mAX4Y__"